import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '🔴',
    title: 'Módulo 1 — Fundamentos y Sistema de Chakras',
    sessions: '~50 páginas',
    months: 'Base conceptual sólida',
    desc: 'Base conceptual sólida para comprender el sistema energético completo y trabajar con criterio profesional.',
    color: 'bg-[#DC2626]',
    borderColor: 'border-t-[#DC2626]'
  }, {
    emoji: '🟠',
    title: 'Módulo 2 — Anatomía Energética y Cuerpos Sutiles',
    sessions: '~50 páginas',
    months: 'Campo energético integral',
    desc: 'Campo energético integral: cuerpos sutiles, capas del aura y cómo interactúan con cada chakra.',
    color: 'bg-[#EA580C]',
    borderColor: 'border-t-[#EA580C]'
  }, {
    emoji: '🟡',
    title: 'Módulo 3 — Técnicas de Armonización y Equilibrio',
    sessions: '~50 páginas',
    months: 'Herramientas prácticas listas',
    desc: 'Herramientas prácticas listas para aplicar en sesión y devolver el equilibrio a cada centro energético.',
    color: 'bg-[#EAB308]',
    borderColor: 'border-t-[#EAB308]'
  }, {
    emoji: '💚',
    title: 'Módulo 4 — Herramientas y Terapias Complementarias',
    sessions: '~50 páginas',
    months: 'Cristales, sonidos y mantras',
    desc: 'Cristales, sonidos, mantras, visualizaciones y elementos simbólicos. Crea sesiones más completas, personalizadas y transformacionales.',
    color: 'bg-[#16A34A]',
    borderColor: 'border-t-[#16A34A]'
  }, {
    emoji: '💜',
    title: 'Módulo 5 — Emociones, Creencias y Bloqueos',
    sessions: '~50 páginas',
    months: 'Dimensión emocional profunda',
    desc: 'Profundiza la relación entre emociones, pensamientos y energía. Patrones emocionales, introspección y herramientas para acompañar procesos reales.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '🔵',
    title: 'Módulo 6 — Profesionalización y Práctica Terapéutica',
    sessions: '~50 páginas',
    months: 'Metodología y organización',
    desc: 'Lleva todo a la práctica. Organización, estructura, metodología, registro de consultantes y comunicación profesional.',
    color: 'bg-[#2563EB]',
    borderColor: 'border-t-[#2563EB]'
  }];
  const features = ['Objetivo claro y visible para dominar ese aspecto', 'Conceptos conectados y organizados progresivamente', 'Técnicas listas para imprimir y aplicar en sesión', 'Recursos de meditación y visualización efectivos', 'Material de consulta permanente — siempre a mano', 'Herramientas complementarias ya integradas', 'Un sistema coherente — nada disperso'];
  const featureChips = ['✅ Domina el sistema energético completo', '✅ TODO conectado y en un solo lugar', '✅ Técnicas probadas listas para aplicar', '✅ Meditaciones y visualizaciones efectivas', '✅ 475 páginas especializadas', '✅ Imprimible — Tenlo siempre a mano'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-19" data-mp="loplsu0hcx3s">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-20" data-mp="hn448vd03un9">
        {/* Gold trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-21" data-mp="1ecv6xhvg4o45">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full" style={{
          background: 'linear-gradient(135deg, #D4A41C 0%, #F0BE2A 50%, #D4A41C 100%)',
          color: '#1A1303',
          boxShadow: '0 0 20px rgba(212,164,28,0.4)'
        }} data-id="element-22" data-mp="1ecd1bumw8xjk">
           🏆 Biblioteca Profesional N°1 para Terapeutas Energéticos 
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase text-txt-primary mb-3 md:mb-4 md:text-[36px] text-[22px] leading-[1.25]" data-id="element-23" data-mp="1sce2zcazg903">
          🔮 BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS{' '}
          <span className="text-brandViolet" data-id="element-24" data-mp="1hu911ush2sq3">CHAKRAS™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-25" data-mp="13ty6ago1ktzn">
          6 Módulos + 5 Bonos — 475 páginas · TODO organizado · Imprimible.
        </p>
      </FadeIn>

      {/* Colored module strip */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-26" data-mp="1vm5nbi7gm8ek">
        <div className="flex justify-center gap-2 md:gap-4 px-2 md:px-0" data-id="element-27" data-mp="20k7hay6fbs4t">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[46px] md:w-28 h-[60px] md:h-36 rounded-md md:rounded-lg shadow-lg flex flex-col items-center justify-center gap-0.5 md:gap-2 p-1 md:p-3 text-center text-white relative overflow-hidden transform hover:-translate-y-1 transition-transform border border-white/20`} data-id="element-28" data-mp="1msslfqrf3wgc" data-mpi={i}>
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-29" data-mp="2jagkaaa1bnxk"></div>
              
              <span className="font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[7.5px] md:text-[10px] leading-tight drop-shadow-md relative z-10" data-id="element-30" data-mp="7uoc7xba09ib">
                Módulo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-31" data-mp="hndmiov3bhc2">
          <span className="inline-block bg-brandViolet text-white font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full" data-id="element-32" data-mp="cnhiwqqb1rx1">
            6 MÓDULOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-33" data-mp="3v0fnjay1l8xj">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-34" data-mp="3v20haycj8nuc">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandViolet/10 text-brandViolet border border-brandViolet/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-35" data-mp="1a9ycbkvx3ldi" data-mpi={i}>
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-36" data-mp="1hclnpnyysxmm">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandViolet/30 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-37" data-mp="1mchsvqjeev3r">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandViolet" data-id="element-38" data-mp="1rajae716emd4">
            📦 Lo que recibes:
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-12 md:mb-16" data-id="element-39" data-mp="ynykzc49gkc7">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-40" data-mp="18d8dgt30o50u" data-mpi={i}>
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-bg-card rounded-[16px] md:rounded-[20px] p-4 md:p-6 border-x border-b transition-all border-t-[3px] ${isOpen ? 'border-brandViolet shadow-[0_0_40px_rgba(139,92,246,0.2)]' : `border-x-line border-b-line ${tomo.borderColor}`}`} aria-expanded={isOpen} data-id="element-41" data-mp="18et8skx5nrzr">
                <div className="flex items-start justify-between gap-3" data-id="element-42" data-mp="2p6ex96hdn8yi">
                  <div className="flex items-start gap-2.5 md:gap-3 min-w-0 flex-1" data-id="element-43" data-mp="2k5hd4oct44ud">
                    <div className="text-2xl md:text-4xl shrink-0" data-id="element-44" data-mp="2f764ggy900dq">
                      {tomo.emoji}
                    </div>
                    <div className="min-w-0" data-id="element-45" data-mp="2a8uum67ydpvi">
                      <h3 className="font-sans font-bold text-[14px] md:text-[17px] text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-46" data-mp="2a9nvwro57n69">
                        {tomo.title}
                      </h3>
                      <div className="flex flex-wrap gap-1.5" data-id="element-47" data-mp="21derszp800ds">
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandViolet bg-brandViolet/10 px-2 py-0.5 rounded" data-id="element-48" data-mp="1whpqorxjybfd">
                          {tomo.sessions}
                        </span>
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-white/5 px-2 py-0.5 rounded" data-id="element-49" data-mp="1mkl5aubj6jzm">
                          {tomo.months}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandViolet text-white rotate-180' : 'bg-bg-highlight text-txt-primary hover:bg-line'}`} data-id="element-50" data-mp="36dcskksc62rn">
                    {isOpen ? <Minus size={14} data-id="element-51" data-mp="2wg70pabwe7qd" /> : <Plus size={14} data-id="element-52" data-mp="2wggiwbqpbali" />}
                  </div>
                </div>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 md:mt-4' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-53" data-mp="2ip1xxzd8gzbt">
                  <div className="overflow-hidden" data-id="element-54" data-mp="28pujf8uriyn4">
                    <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-55" data-mp="28qcqz1mvkzac">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-56" data-mp="1q226ss9ul3j7">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-57" data-mp="1q2v99h1rx6vj">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8" data-id="element-58" data-mp="242d1y7i6x4a6">
            Cada módulo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-59" data-mp="2d0op1zjuljxv">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-60" data-mp="28zd4w9jqtqx2" data-mpi={i}>
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-61" data-mp="2mrt38x1p90rn" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-62" data-mp="2hryg94l1ovbv">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-63" data-mp="2rqwb0p92dl3b">
            <p className="font-sans font-bold text-base md:text-xl text-brandViolet leading-snug" data-id="element-64" data-mp="2rsh4scnk1004">
              Abres la BIBLIOTECA, buscas lo que necesitas, lo imprimes si
              quieres, y lo aplicas. Así de simple. Todo organizado y listo, desde hoy.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🌸',
    title: '365+ Afirmaciones para Cada Chakra',
    desc: 'Una por día. Imprimibles. Listas para usar en tus sesiones transformacionales.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/224NFKMjX1ewtg87H8WET9/BONO_1.webp'
  }, {
    num: '02',
    icon: '🔥',
    title: '100 Rituales de Limpieza y Protección Energética',
    desc: 'Todos los rituales que necesitas. Listos para ejecutar con energía y seguridad.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/uCboZbsmRPUTJDrLCANimS/BONO_2.webp'
  }, {
    num: '03',
    icon: '🧘',
    title: 'Manual de Meditaciones Guiadas para Cada Chakra',
    desc: 'Meditaciones que transforman. Imprimibles. Listas para guiar sesiones.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/37aTwccLzKgxijatTrN72q/BONO_3.webp'
  }, {
    num: '04',
    icon: '📋',
    title: 'Agenda Profesional del Terapeuta Energético',
    desc: 'Registra, planifica y domina cada sesión. Tenlo impreso en tu escritorio.',
    value: 'USD $8',
    image: 'https://cdn.magicpatterns.com/uploads/xzPDko8299kyfAuKDBbfzb/BONO_4.webp'
  }, {
    num: '05',
    icon: '🔮',
    title: 'Manual de Símbolos, Mantras y Frecuencias Sagradas',
    desc: 'Todos los códigos energéticos en un solo lugar. Imprimible. Listo para dominar.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/pbEkeC2ydoHmQxUZS95khB/BONO_5.webp'
  }];
  return <Section className="bg-bg-alt" data-id="element-65" data-mp="2ug86bhynmjot">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-66" data-mp="2uh9e9dkdiq2b">
        <h2 className="font-display font-extrabold uppercase md:text-[40px] text-txt-primary mb-2 md:mb-4 text-[26px]" data-id="element-67" data-mp="2ygibisemh62m">
          + 5 BONOS <span className="text-brandViolet" data-id="element-68" data-mp="5n384q0rr02y">EXCLUSIVOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-69" data-mp="o9vt0x7xf4d">
          Materiales listos para imprimir — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-70" data-mp="aleid1uz7clp">
        {bonuses.map((bono, i) => <FadeIn key={bono.num} delay={Math.min(i * 0.05, 0.2)} data-id="element-71" data-mp="okduxb57s11i" data-mpi={i}>
            <article className="bg-bg-card rounded-[16px] border border-line border-l-[3px] border-l-brandViolet h-full overflow-hidden flex gap-3 p-3 md:gap-4 md:p-4" data-id="element-72" data-mp="jmm3ei8hegxu">
              <img src={bono.image} alt={`Portada del bono ${bono.num}: ${bono.title}`} loading="lazy" decoding="async" width={128} height={171} className="w-24 self-start aspect-[3/4] shrink-0 rounded-[10px] object-cover border border-white/10 md:w-32" data-id="element-73" data-mp="ydbgxr9f084v" />
              <div className="min-w-0 flex flex-1 flex-col" data-id="element-74" data-mp="12dlp9akojamw">
                <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-75" data-mp="1lym5m73n8yl0">
                  <div className="flex items-center gap-1.5" data-id="element-76" data-mp="1lwj52t4v7n21">
                    <span className="text-lg md:text-xl" data-id="element-77" data-mp="1qwnl6i1v2frq">🎁</span>
                    <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandViolet" data-id="element-78" data-mp="1cy7gsxrh11cr">
                      BONO {bono.num}
                    </span>
                  </div>
                  <span className="text-lg md:text-xl" aria-hidden="true" data-id="element-79" data-mp="137uo2i9i61vj">{bono.icon}</span>
                </div>
                <h3 className="font-sans font-bold text-[13.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-80" data-mp="17zw6yn16equj">
                  {bono.title}
                </h3>
                <p className="font-sans text-[12px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-81" data-mp="y8i3y5a0n8wn">
                  {bono.desc}
                </p>
                <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-82" data-mp="p83fwy5o3fpg">
                  <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-83" data-mp="h7x3xdl75xue">
                    {bono.value}
                  </span>
                  <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-84" data-mp="7hudnl5gmxzr">
                    GRATIS
                  </span>
                </div>
              </div>
            </article>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-85" data-mp="3pngto2mnsy4p">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-86" data-mp="3knuj60y7tvzl">
          Valor total de los 5 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-87" data-mp="3golnurnj1q1x">
          USD $40
        </p>
        <p className="font-display font-black text-[20px] md:text-[36px] leading-[1.15] mb-1 md:mb-2 text-[#22C55E]" data-id="element-88" data-mp="1evfl9csxc8a0">
          🎁 GRATIS — CON TU BIBLIOTECA
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-89" data-mp="2wssi3c7t7suq">
          Incluidos en tu Biblioteca, sin costo extra.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds,
    isUrgent
  } = useCountdown();
  const accent = isUrgent ? 'text-danger' : 'text-brandViolet';
  const boxBorder = isUrgent ? 'border-danger' : 'border-brandViolet';
  const boxShadow = isUrgent ? 'shadow-[0_0_25px_rgba(239,68,68,0.45)] animate-red-glow' : 'shadow-[0_0_25px_rgba(139,92,246,0.4)]';
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-90" data-mp="24nlvnxvsc5q">
      <div className="max-w-[1100px] mx-auto" data-id="element-91" data-mp="26qdudilgfd3">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-92" data-mp="72xfhu3yj4p8">
          <div className={`rounded-[20px] border-2 p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto transition-colors ${isUrgent ? 'border-danger shadow-[0_0_50px_rgba(239,68,68,0.25)]' : 'border-brandViolet shadow-[0_0_50px_rgba(139,92,246,0.2),inset_0_0_30px_rgba(139,92,246,0.03)]'}`} data-id="element-93" data-mp="75tfrp3a25gu">
            <h3 className={`font-sans font-bold uppercase tracking-[1.5px] text-[11px] ${accent}`} data-id="element-94" data-mp="2d2osy1v4qi2v">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className={`flex justify-center gap-2.5 md:gap-4 text-white ${isUrgent ? 'animate-red-text-pulse' : 'animate-glow-button'}`} data-id="element-95" data-mp="1kgx05f3glp6d">
              {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-96" data-mp="1u6oty73qie9s" data-mpi={i}>
                  {i > 0 && <div className={`font-display font-black text-[34px] md:text-[46px] py-2 flex items-center ${accent}`} data-id="element-97" data-mp="1u8018gwe245n">
                      :
                    </div>}
                  <div className={`bg-bg-card border-2 rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center transition-colors ${boxBorder} ${boxShadow}`} data-id="element-98" data-mp="11ob9rabbmqt6">
                    <div className={`font-display font-black text-[34px] md:text-[46px] leading-none ${accent}`} data-id="element-99" data-mp="38cl92d1tf0cw">
                      {unit.value.toString().padStart(2, '0')}
                    </div>
                    <div className={`font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] mt-1 ${accent}`} data-id="element-100" data-mp="2zfb1p2s4bvd9">
                      {unit.label}
                    </div>
                  </div>
                </React.Fragment>)}
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-gold leading-snug" data-id="element-101" data-mp="3w3z6uyiqjo59">
              <AlertTriangle size={20} data-id="element-102" data-mp="3i3ocvmm4ptfv" />
              <span data-id="element-103" data-mp="3n2sk47phth3k">Después sube el precio. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-104" data-mp="3n4vk9kkd0qm0">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-105" data-mp="26nhjj5si0ztf">
                <span className="flex items-center gap-2" data-id="element-106" data-mp="2blj5byhb7d8l">
                  <span className="w-2 h-2 rounded-full bg-brandViolet animate-pulse" data-id="element-107" data-mp="32eqs1crh3ec4"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandViolet font-bold" data-id="element-108" data-mp="2tcr9uh4q247l">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-109" data-mp="2oeprjyf4e8x6">
                <div className="bg-brandViolet h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-110" data-mp="3m1onu81wheuj"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-111" data-mp="3h3ddlw7p12bs">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const includes = [{
    icon: '📚',
    label: '6 Módulos Principales',
    detail: 'TODO lo que necesitas dominar en un solo lugar',
    price: 'USD $39'
  }, {
    icon: '🎁',
    label: '5 Bonos Exclusivos',
    detail: 'Afirmaciones, rituales, meditaciones — TODO imprimible',
    price: 'USD $40'
  }];
  return <Section className="bg-bg-alt !pt-6 !pb-8 md:!pt-12 md:!pb-14" id="pricing" data-id="element-112" data-mp="g7m6ztu8hith">
      <div className="max-w-lg mx-auto" data-id="element-113" data-mp="l54gpmg2s22j">
        <FadeIn className="text-center mb-5 md:mb-7" data-id="element-114" data-mp="l42wosh3058o">
          <p className="font-sans text-[12.5px] md:text-[15px] text-txt-body" data-id="element-115" data-mp="q5a3ao7hmydr">
            Estás a un paso de tener TODO organizado y listo para dominar...
          </p>
          <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[40px] leading-[1.15] text-txt-primary mt-2 max-w-[18ch] md:max-w-none mx-auto" data-id="element-116" data-mp="u4hrcifxqwou">
            OFERTA ESPECIAL DE{' '}
            <span className="text-brandViolet" data-id="element-117" data-mp="13yhvoi3e7xwi">LANZAMIENTO</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-118" data-mp="18x2tkav6a5hs">
          <div className="relative rounded-[20px] md:rounded-[24px] border-2 border-brandViolet bg-bg-card px-4 pt-7 pb-4 md:px-7 md:pt-9 md:pb-6 shadow-[0_0_60px_rgba(139,92,246,0.22),inset_0_0_30px_rgba(139,92,246,0.03)]" data-id="element-119" data-mp="1duux6256jg1t">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandViolet text-white font-sans font-bold uppercase tracking-[1.5px] text-[9.5px] md:text-[11px] px-3 py-1 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(139,92,246,0.5)]" data-id="element-120" data-mp="2hdbumzcvcfuv">
              ⭐ MÁS ELEGIDO
            </div>

            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mb-3 md:mb-4" data-id="element-121" data-mp="2vcl0b53g7rkl">
              Lo que incluye tu Biblioteca
            </p>

            <ul className="divide-y divide-line border-y border-line" data-id="element-122" data-mp="358o9uw0mqshk">
              {includes.map(item => <li key={item.label} className="flex items-center justify-between gap-3 py-2.5 md:py-3" data-id="element-123" data-mp="3a20n69zuzcv0">
                  <div className="flex items-start gap-2 min-w-0" data-id="element-124" data-mp="3eyhe1byg05bs">
                    <span className="text-[15px] md:text-lg leading-none mt-0.5" aria-hidden="true" data-id="element-125" data-mp="3j1w28pwjbs0b">
                      {item.icon}
                    </span>
                    <div className="min-w-0" data-id="element-126" data-mp="3ny4dvtbix32q">
                      <p className="font-sans font-bold text-[12.5px] md:text-[15px] text-txt-primary leading-snug" data-id="element-127" data-mp="1cddjtdjbrgwy">
                        {item.label}
                      </p>
                      <p className="font-sans text-[10.5px] md:text-[12.5px] leading-[1.35] text-txt-muted" data-id="element-128" data-mp="13c5sjff87gcd">
                        {item.detail}
                      </p>
                    </div>
                  </div>
                  <span className="font-sans font-bold text-[12.5px] md:text-[15px] line-through text-danger shrink-0" data-id="element-129" data-mp="1v2jwojxfteau">
                    {item.price}
                  </span>
                </li>)}
            </ul>

            <div className="pt-3 md:pt-4 text-center" data-id="element-130" data-mp="1ma04o2bni7yz">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-131" data-mp="1hcgfi7df0as9">
                Valor original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-132" data-mp="2etoxpdcd9tdk">
                USD $79
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandViolet/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-133" data-mp="2sxnuysigl3fg">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandViolet" data-id="element-134" data-mp="2xy1z3zgxvt87">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[42px] md:text-[58px] leading-none text-brandViolet mt-1" data-id="element-135" data-mp="2o4kz2dq7lhw3">
                $24{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-136" data-mp="2f692zw6kprw9">
                  USD
                </span>
              </p>
              <p className="font-sans font-bold text-[11px] md:text-[13px] text-success mt-2" data-id="element-137" data-mp="2181ac0gklcqw">
                70% de descuento — Solo en lanzamiento
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-138" data-mp="3vl0tg3k5sp2x">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-139" data-mp="1nz971g52tdsa" />

            <div className="mt-4 md:mt-5" data-id="element-140" data-mp="1jwmbb45ab8pt">
              <CTAButton href={PRODUCTS.biblioteca.checkoutUrl} fullWidth trackingProduct="biblioteca" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[13.5px] md:!text-base" data-id="element-141" data-mp="1jxnp3gdoq9b8">
                💜 QUIERO LA BIBLIOTECA COMPLETA
              </CTAButton>
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-2.5 md:mt-3.5 font-sans text-[10px] md:text-[12.5px] text-txt-muted" data-id="element-142" data-mp="27lyhdv5bf0nw">
                <span data-id="element-143" data-mp="22p81p8xfa730">🔒 Pago seguro</span>
                <span data-id="element-144" data-mp="2gneqlzke8wqj">⚡ Acceso en minutos</span>
                <span data-id="element-145" data-mp="2gm3oe46ljx1j">🛡️ Garantía 7 días</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};